import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import { fileUploadApi, getApi, postApi } from "../../../utils/services";
import { CREATE_PETTY_CASH_BILL, FILE_UPLOAD, PETTY_CASH_FUND_TOTAL, VENDOR_ITEMS, PETTY_CASH_LIST, PETTY_CASH_FUND_LIST } from "../../../utils/apiRoutes";
import { ADMIN_EXECUTIVE_ID, PROSPECT_VENDOR_SITE_CONFIGERATION_ID } from "../../../utils/constant";
import BackButton from "../../../assets/image/BackButton";
import DeleteIcon from "../../../assets/image/DeleteIcon";
import { useTransactionContext } from "../../../utils/helpers/useTransaction";
import PettyCashValidation from "../../../middleware/pettyCashValidation";
import { fetchConfigeration, fetchPettyCashFunds, handleDepartmentList, handleRemoveItem } from "../../../utils/helpers/globalMethod";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TEXT_LENGTH, VENDOR_NAME_LENGTH_ERROR } from "../../../utils/helpers/globalErrorMessage";
import Select from 'react-select';
import moment from "moment";

const INITIAL_ITEM = {
    itemId: '',
    description: '',
    departmentId: '',
    amount: '',
    comment: '',
    attachDoc: [],
    vendorName: '',
    billDate: ''
};

const PettyCashPage = () => {
    const user = JSON.parse(localStorage.getItem("userData"));
    const navigate = useNavigate();
    const transactionList = useTransactionContext();

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentISODate = currentDate.toISOString().split('T')[0];
    const currentMonth = currentISODate.substring(0, 7);

    const [monthFilter, setMonthFilter] = useState(currentMonth);
    const [dateRange, setDateRange] = useState({
        minDate: `${currentMonth}`,
        maxDate: currentISODate
    });
    const [selectedFundNumbers, setSelectedFundNumbers] = useState([]);
    const [fundNumberOptions, setFundNumberOptions] = useState([]);
    const [fundListData, setFundListData] = useState([]);
    const [loadingFundNumbers, setLoadingFundNumbers] = useState(false);
    const [totalRemainingFund, setTotalRemainingFund] = useState(0);
    const [neededFund, setNeededFund] = useState(0); // Add this new state
    const [showNeededFund, setShowNeededFund] = useState(false);


    const [year, month] = monthFilter.split('-');
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year, 10);
    const lastDayOfMonth = new Date(yearInt, monthInt, 0).getDate();
    const headerBillDate = `${monthFilter}-${lastDayOfMonth.toString().padStart(2, '0')}`;

    const [departmentList, setDepartmentList] = useState([])
    const [vendorId, setVendorId] = useState("")
    const [remainingFund, setRemainingFund] = useState();

    const [formData, setFormData] = useState({
        billDate: currentISODate,
    });

    const [itemDescriptionLineLevel, setItemDescriptionLineLevel] = useState([{
        ...INITIAL_ITEM,
        billDate: currentISODate
    }]);

    const [subTotal, setSubTotal] = useState(0);
    const [loadingStates, setLoadingStates] = useState({
        save: false,
        submit: false,
    });
    const [actionInProgress, setActionInProgress] = useState(false);
    const [itemsList, setItemsList] = useState([]);
    const { errors, setErrors, validateForm } = PettyCashValidation();

    useEffect(() => {
        const fetchList = async () => {
            await handleDepartmentList(setDepartmentList);
        };
        fetchList();
    }, []);

    useEffect(() => {
        const fetchItemsList = async () => {
            try {
                if (vendorId) {
                    const response = await getApi(`${VENDOR_ITEMS}/${vendorId}`);
                    setItemsList(response.res.itemsList);
                }
            } catch (error) {
                console.error("Error fetching items list:", error);
            }
        };

        fetchItemsList();
    }, [vendorId]);

    useEffect(() => {
        fetchConfigeration(setVendorId, PROSPECT_VENDOR_SITE_CONFIGERATION_ID);
    }, []);

    useEffect(() => {
        const loadFunds = async () => {
            setLoadingFundNumbers(true);
            const {
                allFunds,
                validFunds,
                totalRemaining,
                totalNeeded,
                options
            } = await fetchPettyCashFunds();

            setFundListData(allFunds);
            setTotalRemainingFund(totalRemaining);
            setFundNumberOptions(options);

            if (totalNeeded > 0) {
                setNeededFund(totalNeeded);
                setShowNeededFund(true);
            } else {
                setShowNeededFund(false);
            }

            setLoadingFundNumbers(false);
        };

        loadFunds();
    }, []);

    // useEffect(() => {
    //     if (!monthFilter) {
    //         setDateRange({
    //             minDate: `${currentYear}-01-01`,
    //             maxDate: currentISODate
    //         });
    //         return;
    //     }

    //     const [year, month] = monthFilter.split('-');
    //     const monthInt = parseInt(month, 10);
    //     const yearInt = parseInt(year, 10);

    //     if (yearInt !== currentYear) {
    //         setMonthFilter(currentMonth);
    //         return;
    //     }

    //     const firstDay = `${monthFilter}-01`;
    //     const lastDay = new Date(yearInt, monthInt, 0).getDate();
    //     const maxDate = `${monthFilter}-${lastDay.toString().padStart(2, '0')}`;

    //     const finalMaxDate = monthFilter === currentMonth.substring(0, 7) ?
    //         (currentISODate > maxDate ? maxDate : currentISODate) :
    //         maxDate;

    //     setDateRange({
    //         minDate: firstDay,
    //         maxDate: finalMaxDate
    //     });

    //     setItemDescriptionLineLevel(prev => prev.map(item => ({
    //         ...item,
    //         billDate: firstDay
    //     })));

    // }, [monthFilter, currentMonth, currentISODate, currentYear]);

    useEffect(() => {
        const newSubTotal = itemDescriptionLineLevel.reduce(
            (acc, item) => acc + (parseFloat(item.amount) || 0),
            0
        );
        setSubTotal(parseFloat(newSubTotal.toFixed(2)));
        setErrors(prev => ({ ...prev, subTotalLineLevel: undefined }));
    }, [itemDescriptionLineLevel, setErrors]);

    const handleMonthFilterChange = (e) => {
        const selectedMonth = e.target.value;

        if (!selectedMonth) {
            return;
        }
        // const selectedYear = selectedMonth.split('-')[0];
        // // if (selectedYear !== currentYear.toString()) {
        // //     setMonthFilter(currentMonth);
        // //     return;
        // // }
        setMonthFilter(selectedMonth);
    };

    const handleFundNumberChange = (selectedOptions) => {
        setSelectedFundNumbers(selectedOptions || []);

        setErrors(prev => {
            const updated = { ...prev };
            if (updated.fundSelection) {
                delete updated.fundSelection;
            }
            return updated;
        });
    };

    const handleFileChange = useCallback((e, index) => {
        const file = e.target.files[0];
        if (!file) return;

        setItemDescriptionLineLevel(prev => {
            const updated = [...prev];
            updated[index].attachDoc = [file];
            return updated;
        });

        setErrors(prev => {
            const updated = { ...prev };
            if (updated.itemDescriptionLineLevel?.[index]?.attachDoc) {
                delete updated.itemDescriptionLineLevel[index].attachDoc;

                if (Object.keys(updated.itemDescriptionLineLevel[index]).length === 0) {
                    delete updated.itemDescriptionLineLevel[index];

                    if (Object.keys(updated.itemDescriptionLineLevel).length === 0) {
                        delete updated.itemDescriptionLineLevel;
                    }
                }
            }
            return updated;
        });
    }, [setErrors]);

    const handleClearFile = useCallback((index, e) => {
        e.stopPropagation();

        const fileInputs = document.querySelectorAll('.file-input');
        if (fileInputs[index]) {
            fileInputs[index].value = '';
        }

        setItemDescriptionLineLevel(prev => {
            const updated = [...prev];
            updated[index].attachDoc = [];
            return updated;
        });

        setErrors(prev => {
            const updated = { ...prev };
            if (updated.itemDescriptionLineLevel?.[index]?.attachDoc) {
                delete updated.itemDescriptionLineLevel[index].attachDoc;

                if (Object.keys(updated.itemDescriptionLineLevel[index]).length === 0) {
                    delete updated.itemDescriptionLineLevel[index];

                    if (Object.keys(updated.itemDescriptionLineLevel).length === 0) {
                        delete updated.itemDescriptionLineLevel;
                    }
                }
            }
            return updated;
        });
    }, [setErrors]);

    const handleViewFile = useCallback((file) => {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
    }, []);

    const handleItemChange = useCallback((e, index) => {
        const { name, value } = e.target;

        // if (name === "billDate") {
        //     const selectedMonth = value.substring(0, 7);
        //     if (selectedMonth !== monthFilter) {
        //         return;
        //     }
        // }

        let newValue = value;

        if ((name === "description" || name === "comment") && value.length > 200) {
            setErrors(prev => ({
                ...prev,
                itemDescriptionLineLevel: {
                    ...(prev.itemDescriptionLineLevel || {}),
                    [index]: {
                        ...(prev.itemDescriptionLineLevel?.[index] || {}),
                        [name]: TEXT_LENGTH,
                    }
                }
            }));
            return;
        }

        if (name === "vendorName" && value.length > 50) {
            setErrors(prev => ({
                ...prev,
                itemDescriptionLineLevel: {
                    ...(prev.itemDescriptionLineLevel || {}),
                    [index]: {
                        ...(prev.itemDescriptionLineLevel?.[index] || {}),
                        [name]: VENDOR_NAME_LENGTH_ERROR,
                    }
                }
            }));
            return;
        }

        if (name === "amount") {
            newValue = value.replace(/[^0-9.]/g, '');
            const parts = newValue.split('.');
            if (parts.length > 2) newValue = parts[0] + '.' + parts.slice(1).join('');
            const dotIndex = newValue.indexOf(".");
            if (dotIndex !== -1 && newValue.length - dotIndex > 3) {
                newValue = newValue.slice(0, dotIndex + 3);
            }
        }

        setItemDescriptionLineLevel(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [name]: newValue };
            return updated;
        });

        setErrors(prev => {
            const updated = { ...prev };
            if (updated.itemDescriptionLineLevel?.[index]) {
                delete updated.itemDescriptionLineLevel[index][name];
            }
            return updated;
        });
    }, [monthFilter, setErrors]);

    const handleAddLine = useCallback(() => {
        setItemDescriptionLineLevel(prev => [...prev, {
            ...INITIAL_ITEM,
            billDate: dateRange.minDate
        }]);
    }, [dateRange.minDate]);

    const handleRemove = (index) => {
        handleRemoveItem(index, itemDescriptionLineLevel, setItemDescriptionLineLevel, errors, setErrors);
    };

    const calculateFundAllocation = (selectedFunds, totalAmount) => {
        if (!selectedFunds || selectedFunds.length === 0) return [];

        let remainingAmount = parseFloat(totalAmount.toFixed(2));
        const allocatedFunds = [];
        const sortedFunds = [...selectedFunds].sort((a, b) => a.fundId - b.fundId);

        for (const fund of sortedFunds) {
            if (remainingAmount <= 0) break;

            const fundAmount = parseFloat(Math.min(fund.remainingAmount, remainingAmount).toFixed(2));
            allocatedFunds.push({
                fundAmount: fundAmount,
                fundId: fund.fundId
            });

            remainingAmount = parseFloat((remainingAmount - fundAmount).toFixed(2));
        }

        return allocatedFunds;
    };

    const handleSubmit = async (e, actionType) => {
        e.preventDefault();

        if (actionInProgress) return;
        setActionInProgress(true);

        try {
            const isValid = validateForm(
                itemDescriptionLineLevel,
                subTotal,
                selectedFundNumbers,
                fundListData
            );

            if (!isValid) {
                setActionInProgress(false);
                return;
            }

            setLoadingStates(prev => ({ ...prev, [actionType.toLowerCase()]: true }));


            const getVendorNameFirstWord = (vendorName) => {
                if (vendorName) {
                    const firstWord = vendorName.trim().split(' ')[0];
                    return firstWord.toLowerCase().replace(/[^a-z0-9]/g, '');
                }
                return 'vendor';
            };

            const uploadTasks = itemDescriptionLineLevel
                .filter(item => item.attachDoc && item.attachDoc.length > 0)
                .flatMap((item, itemIndex) => {
                    const folderName = getVendorNameFirstWord(item.vendorName);
                    return item.attachDoc.map(file => {
                        const formData = new FormData();
                        formData.append('files', file);
                        formData.append('folderName', folderName);
                        formData.append('transactionName', 'pettycash');
                        formData.append('vendorId', vendorId);

                        return {
                            task: fileUploadApi(FILE_UPLOAD, formData),
                            itemIndex,
                            folderName
                        };
                    });
                });

            const uploadResults = await Promise.all(uploadTasks.map(e => e.task));

            const allFiles = uploadResults.flatMap(res => res.res.files);

            let fileIndex = 0;

            // Calculate fund allocation
            const selectedFunds = selectedFundNumbers.map(fund => ({
                fundNo: fund.value,
                fundId: fund.fundId,
                remainingAmount: fund.remainingAmount
            }));

            const allocatedFunds = calculateFundAllocation(selectedFunds, subTotal);

            const payload = {
                vendorId: Number(vendorId),
                transactionId: transactionList[5].id,
                roleId: user.RoleId,
                billDate: headerBillDate,
                itemDescription: itemDescriptionLineLevel.map((item, itemIndex) => {
                    const itemPayload = {
                        itemId: Number(item.itemId),
                        rate: Number(item.amount) || 0,
                        quantity: 1,
                        departmentId: Number(item.departmentId),
                        totalAmount: Number(item.amount) || 0,
                        billDate: item.billDate,
                        itemDescription: item.description || null,
                        comment: item.comment || null,
                        vendorName: item.vendorName || null,
                    };

                    if (item.attachDoc && item.attachDoc.length > 0) {
                        itemPayload.fileName = allFiles[fileIndex].FileName;
                        itemPayload.filePath = allFiles[fileIndex].FilePath;
                        fileIndex++;
                    }

                    return itemPayload;
                }),
                grandTotal: subTotal,
                actionType: actionType,
                funds: allocatedFunds
            };

            const result = await postApi(CREATE_PETTY_CASH_BILL, payload);

            if (result.res.success) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: result.res.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
                navigate("/petty-cash-listing");
            }

        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setLoadingStates({ save: false, submit: false });
            setActionInProgress(false);
        }
    };

    const getMonthStartDate = (month) => {
    if (!month) return '';
    return `${month}-01`;
};


    return (
        <>
            <Helmet>
                <title>Vendor Portal || Petty Cash Bill</title>
            </Helmet>

            <div className="container-section">
                <div className="section-header d-flex justify-content-between align-items-center gap-2 flex-wrap">
                    <div className="d-flex align-items-center">
                        <button onClick={() => navigate(-1)} className="back-viewbtn me-2">
                            <div className="svgsize">
                                <BackButton />
                            </div>
                        </button>
                        <h3>Petty Cash Bill</h3>
                    </div>

                    <div className="d-flex align-items-center mb-1 mt-1">
                        <div className="wallet-container position-relative">
                            {showNeededFund ? (
                                <>
                                    <span className="wallet-label">Total Available Funds</span>
                                    <span className="wallet-amount text-danger">
                                        - ₹ {neededFund.toFixed(2)}
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span className="wallet-label">Total Available Funds</span>
                                    <span className="wallet-amount text-success">
                                        ₹ {totalRemainingFund.toFixed(2)}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>

                </div>

                <form>
                    <div className="form-style ">
                        <div className="row">
                            <div className="col-md-3 mb-20">
                                <div className="form-group">
                                    <label className="form-label">Month</label>
                                    <input
                                        type="month"
                                        className="form-control"
                                        value={monthFilter}
                                        onChange={handleMonthFilterChange}
                                        // min={`${currentYear}-01`}
                                        // max={currentMonth}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group position-relative">
                                    <label className="form-label">Fund Numbers</label>
                                    <Select
                                        isMulti
                                        isSearchable={false}
                                        options={fundNumberOptions}
                                        value={selectedFundNumbers}
                                        onChange={handleFundNumberChange}
                                        isLoading={loadingFundNumbers}
                                        placeholder="Select Fund Numbers..."
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        getOptionValue={(option) => option.value}
                                    />
                                    {errors.fundSelection && (
                                        <span className="error-text">
                                            {errors.fundSelection}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-style">
                        <div className="section-sub-heading">
                            <h3>Prospect Vendors</h3>
                        </div>

                        <div className="pur-item-list table-responsive tbl-body-shadow">
                            <table className="w-100 table table-theme-1 mb-0">
                                <thead className="table-heads">
                                    <tr>
                                        <th className="text-center">Bill Date</th>
                                        <th className="text-center">Vendor Name</th>
                                        <th className="text-center">Item</th>
                                        <th className="text-center">Description</th>
                                        <th className="text-center">Department</th>
                                        <th className="text-center">Amount</th>
                                        <th className="text-center">Comment</th>
                                        <th className="text-center">File</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemDescriptionLineLevel.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ minWidth: '150px' }}>
                                                <div className="position-relative">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        name="billDate"
                                                        value={item.billDate}
                                                        onFocus={() => {
                                                        if (!item.billDate || !item.billDate.startsWith(monthFilter)) {
                                                            handleItemChange(
                                                                { target: { name: "billDate", value: getMonthStartDate(monthFilter) } },
                                                                index
                                                            );
                                                        }
                                                    }}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                        // min={dateRange.minDate}
                                                        // max={dateRange.maxDate}
                                                    // onKeyDown={(e) => e.preventDefault()}
                                                    />
                                                    {errors.itemDescriptionLineLevel?.[index]?.billDate && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].billDate}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="custom-width">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control mb-20"
                                                        name="vendorName"
                                                        autoComplete="off"
                                                        placeholder="Enter Vendor Name"
                                                        value={item.vendorName}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                    />
                                                    {errors.itemDescriptionLineLevel?.[index]?.vendorName && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].vendorName}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ width: '200px', minWidth: '200px' }}>
                                                <div className="position-relative">
                                                    <select
                                                        className="form-select"
                                                        name="itemId"
                                                        value={item.itemId}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                    >
                                                        <option value="">Select</option>
                                                        {itemsList.map((itemOption) => (
                                                            <option
                                                                key={itemOption.itemId}
                                                                value={itemOption.itemId}
                                                            >
                                                                {itemOption.itemname}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.itemDescriptionLineLevel?.[index]?.itemId && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].itemId}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ width: '220px', minWidth: '220px' }}>
                                                <div className="position-relative">
                                                    <textarea
                                                        name="description"
                                                        className="form-control"
                                                        rows="1"
                                                        value={item.description}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                    />
                                                    {errors.itemDescriptionLineLevel?.[index]?.description && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].description}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ width: '220px', minWidth: '220px' }}>
                                                <div className="position-relative">
                                                    <select
                                                        name="departmentId"
                                                        className="form-select"
                                                        value={item.departmentId}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                    >
                                                        <option value="">Select</option>
                                                        {departmentList.map((dept) => (
                                                            <option key={dept.DepartmentId} value={dept.DepartmentId}>
                                                                {dept.DepartmentName}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.itemDescriptionLineLevel?.[index]?.departmentId && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].departmentId}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ minWidth: '140px' }}>
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control text-end mb-20"
                                                        name="amount"
                                                        autoComplete="off"
                                                        placeholder="Amount"
                                                        value={item.amount}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                    />
                                                    {errors.itemDescriptionLineLevel?.[index]?.amount && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].amount}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ width: '220px', minWidth: '220px' }}>
                                                <div className="position-relative">
                                                    <textarea
                                                        name="comment"
                                                        className="form-control"
                                                        rows="1"
                                                        value={item.comment}
                                                        onChange={(e) => handleItemChange(e, index)}
                                                        placeholder="Add comment"
                                                    />
                                                    {errors.itemDescriptionLineLevel?.[index]?.comment && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].comment}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td style={{ width: '290px', minWidth: '290px' }}>
                                                <div className={`position-relative`}>
                                                    <div className="d-flex position-relative align-items-center">
                                                        <div className="input-group file-input-container position-relative">
                                                            <input
                                                                className="form-control file-input"
                                                                type="file"
                                                                accept=".pdf,.jpg,.jpeg,.png"
                                                                onChange={(e) => handleFileChange(e, index)}
                                                                onClick={(e) => {
                                                                    if (item.attachDoc.length > 0) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                style={{ cursor: item.attachDoc.length > 0 ? 'not-allowed' : 'pointer' }}
                                                            />
                                                            {item.attachDoc.length > 0 && (
                                                                <span
                                                                    className="mdi mdi-close-circle file-preview-cross"
                                                                    onClick={(e) => handleClearFile(index, e)}
                                                                ></span>
                                                            )}
                                                        </div>

                                                        {item.attachDoc.length > 0 && (
                                                            <div className="cstm-preview-container">
                                                                <div className="cstm-view-file m-0">
                                                                    <button
                                                                        type="button"
                                                                        className="btn"
                                                                        onClick={() => handleViewFile(item.attachDoc[0])}
                                                                    >
                                                                        View
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    {errors.itemDescriptionLineLevel?.[index]?.attachDoc && (
                                                        <span className="error-text">
                                                            {errors.itemDescriptionLineLevel[index].attachDoc}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td className="custom-width">
                                                <div className="cursor-pointer d-flex align-items-center justify-content-center mb-20">
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip
                                                                className="custom-tooltip"
                                                                id="tooltips1"
                                                            >
                                                                Delete
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span
                                                            className=""
                                                            onClick={(e) => handleRemove(index, e)}
                                                        >
                                                            <DeleteIcon />
                                                        </span>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="Addmoreicon">
                            <button type="button" className="addIcon" onClick={handleAddLine}>
                                <p>+</p>
                            </button>
                        </div>

                        <div className="d-flex justify-content-end inv-gst-tbl-cont mb-3 mt-4">
                            <div className="GST-bill-width">
                                <div className="d-flex align-items-center mb-2">
                                    <span className="gst-cont-label">Grand Total</span>
                                    <span className="gst-cont-semicolumn">:</span>
                                    <span className="gst-cont-input">
                                        <input
                                            type="text"
                                            value={`₹ ${subTotal.toFixed(2)}`}
                                            className="form-control text-end"
                                            disabled
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end mb-20">
                            <div className="success-btn ms-2">
                                <button
                                    type="submit"
                                    className="btn"
                                    onClick={(e) => handleSubmit(e, "Save")}
                                    disabled={actionInProgress || loadingStates.submit}
                                >
                                    {loadingStates.save ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                                            Loading...
                                        </>
                                    ) : (
                                        "Save"
                                    )}
                                </button>
                            </div>

                            <div className="success-btn ms-2">
                                <button
                                    type="button"
                                    className="btn"
                                    onClick={(e) => handleSubmit(e, "Submit")}
                                    disabled={actionInProgress || loadingStates.save}
                                >
                                    {loadingStates.submit ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                                            Loading...
                                        </>
                                    ) : (
                                        "Submit"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default PettyCashPage;